module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Content_PhotosetViewer #photosetDl":{"hooks.onLoaded":[{"value":function () {
var preview = this.getObject().get('accessibility.previewsForGuests');
if (preview === 0 && !fox.site.member) {
fox.site.gotoPage('');
return;
};
this.dispatchEvent('loaded');
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101013},"path":"~.Content_PhotosetViewer #photosetDl","_fox_":1}]},"~.MC_Photoset_Gallery #photoset #dl":{"hooks.onLoaded":[{"value":function () {
var count = this.getObject().getCount();
var preview = this.getObject().get('accessibility.previewsForGuests');
if (!fox.site.member && preview !== 2) {
fox.site.gotoPage('');
return;
}
if (count === 0) {
fox.site._gotoPage('upgrade');
return;
}
this.dispatchEvent('loaded');
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101028},"path":"~.MC_Photoset_Gallery #photoset #dl","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/accessibility.js
// module id = 678
// module chunks = 4